export default {
  listTitleTable: {
    TICKER: 'MÃ',
    TYPE: 'LOẠI HÌNH',
    _15MINUTES: '15 PHÚT',
    HOURLY: '1 GIỜ',
    DAILY: '1 NGÀY',
    WEEKLY: '1 TUẦN',
  },
  MOVING_AVERAGE: 'Tb Động',
  INDICATORS: 'Chỉ tiêu',
  SUMMARY: 'Tổng quan',

  BULLISH: 'Tăng',
  BEARISH: 'Giảm',
  NEUTRAL: 'Trung tính',
  STRONG_BULLISH: 'Tăng mạnh',
  STRONG_BEARISH: 'Giảm mạnh',
};
